const state = {
	user: null,
	signedIn: false,
	isAdmin: false,
	sessionToken: '',

	proRequest: false
}

const getters = {
	signedIn: state => {
		return state.signedIn
	},
	user: state => {
		return state.user
	},
	isAdmin: state => {
		return state.isAdmin
	},
	sessionToken: state => {
		return state.sessionToken
	},
	isProRequest: state => {
		return state.proRequest
	}
}

const mutations = {
	setSignedIn: (state, data: boolean) => {
		state.signedIn = data
	},

	setUser: (state, data: UserData) => {
		state.user = data
	},

	setProRequest: (state, data: boolean) => {
		state.proRequest = data
	},

	setAdmin: (state, data: boolean) => {
		state.isAdmin = data
	},

	setSessionToken: (state, data: string) => {
		state.sessionToken = data
	}
}

export default {
	namespaced: true,
	state,
	getters,
	mutations
}
